/**
 * @generated SignedSource<<41b2f6b2fad4116807f21374fd0d92ce>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type NftPdpSplitComponent_address$data = {
  readonly " $fragmentSpreads": FragmentRefs<"Recipients_address">;
  readonly " $fragmentType": "NftPdpSplitComponent_address";
};
export type NftPdpSplitComponent_address$key = {
  readonly " $data"?: NftPdpSplitComponent_address$data;
  readonly " $fragmentSpreads": FragmentRefs<"NftPdpSplitComponent_address">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "NftPdpSplitComponent_address",
  "selections": [
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "Recipients_address"
    }
  ],
  "type": "EthereumAddressType",
  "abstractKey": null
};

(node as any).hash = "1a15cbc06d389930efdb0d584302ae0d";

export default node;
